export const FILTER_NAME = 'company'
